import axios from 'axios';
import type { IGetManagedAccessByUserResponse } from '@/app-package';

/**
 * Fetches managed access appointments for a user
 *
 * @param startDate - ISO string representing the start of the date range to fetch appointments for
 * @param endDate - ISO string representing the end of the date range to fetch appointments for
 * @param limit - number of records to return per page (for pagination)
 * @param page - page number to return (for pagination)
 * @param source - whether to fetch appointments where the user is the 'grantee' or 'grantor', if ommitted
 *    all results where the user is either the grantee or grantor will be returned
 * @param listingId - filter to only return appointments for a specific listing
 */
const getManagedAccessByUser = async ({
  startDate,
  endDate,
  limit,
  page,
  source,
  listingId,
}: {
  startDate?: string;
  endDate?: string;
  limit?: number;
  page?: number;
  source?: 'grantee' | 'grantor';
  listingId?: string;
}) => {
  const { data } = await axios.get<IGetManagedAccessByUserResponse>(
    `/supra/managed_access`,
    {
      params: {
        startDate,
        endDate,
        limit,
        page,
        source,
        listingId,
      },
    },
  );

  return data;
};

export default getManagedAccessByUser;
